import Vue from 'vue';
import SharedComponents from '../components/shared';

Vue.use(SharedComponents);


//////////////////
// WEBPACK FOOTER
// ./src/plugins/shared-components.js
// module id = ./src/plugins/shared-components.js
// module chunks = 34